var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({ 
        callback: function (isVisible) { return _vm.isInViewport = isVisible; },
        once: true, 
        intersection: { 
            threshold: .31 
        } 
    }),expression:"{ \n        callback: isVisible => isInViewport = isVisible,\n        once: true, \n        intersection: { \n            threshold: .31 \n        } \n    }"}],class:[
        'image-lazy', 
        { 
            'is-ready': _vm.isReady && _vm.isInViewport, 
            'is-error': _vm.isError 
        } 
    ]},[_c('div',{ref:"placeholder",style:({ height: _vm.heightInPixels })},[(_vm.isBackground && _vm.imageObject)?_c('div',{staticClass:"image-lazy-background",style:({ backgroundImage: 'url('+ _vm.imageObject.src +')' })}):_vm._e(),_c('Loader',{attrs:{"is-active":!_vm.isReady}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }